// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ElevatorFaultMessage, ElevatorFaultMessageT } from './elevator-fault-message';
import { EscalatorFaultMessage, EscalatorFaultMessageT } from './escalator-fault-message';
import { FaultContent, unionToFaultContent, unionListToFaultContent } from './fault-content';


export class FaultMessage implements flatbuffers.IUnpackableObject<FaultMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):FaultMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsFaultMessage(bb:flatbuffers.ByteBuffer, obj?:FaultMessage):FaultMessage {
  return (obj || new FaultMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsFaultMessage(bb:flatbuffers.ByteBuffer, obj?:FaultMessage):FaultMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new FaultMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

faultType():FaultContent {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : FaultContent.NONE;
}

fault<T extends flatbuffers.Table>(obj:any):any|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
}

static startFaultMessage(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addFaultType(builder:flatbuffers.Builder, faultType:FaultContent) {
  builder.addFieldInt8(0, faultType, FaultContent.NONE);
}

static addFault(builder:flatbuffers.Builder, faultOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, faultOffset, 0);
}

static endFaultMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  builder.requiredField(offset, 6) // fault
  return offset;
}

static createFaultMessage(builder:flatbuffers.Builder, faultType:FaultContent, faultOffset:flatbuffers.Offset):flatbuffers.Offset {
  FaultMessage.startFaultMessage(builder);
  FaultMessage.addFaultType(builder, faultType);
  FaultMessage.addFault(builder, faultOffset);
  return FaultMessage.endFaultMessage(builder);
}

unpack(): FaultMessageT {
  return new FaultMessageT(
    this.faultType(),
    (() => {
      const temp = unionToFaultContent(this.faultType(), this.fault.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })()
  );
}


unpackTo(_o: FaultMessageT): void {
  _o.faultType = this.faultType();
  _o.fault = (() => {
      const temp = unionToFaultContent(this.faultType(), this.fault.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })();
}
}

export class FaultMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public faultType: FaultContent = FaultContent.NONE,
  public fault: ElevatorFaultMessageT|EscalatorFaultMessageT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const fault = builder.createObjectOffset(this.fault);

  return FaultMessage.createFaultMessage(builder,
    this.faultType,
    fault
  );
}
}
